import { cn } from '@/lib/utils';

interface SkeletonLoaderProps {
  className?: string;
  count?: number;
  type?: 'text' | 'card' | 'list';
}

export function SkeletonLoader({ className, count = 1, type = 'text' }: SkeletonLoaderProps) {
  const items = Array.from({ length: count }, (_, i) => i);

  if (type === 'card') {
    return (
      <>
        {items.map((index) => (
          <div key={index} className={cn('mx-4 rounded-lg border bg-white p-4', className)}>
            <div className="space-y-3">
              <div className="skeleton-loader h-6 w-3/4 rounded" />
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <div className="skeleton-loader h-4 w-full rounded" />
                  <div className="skeleton-loader h-5 w-2/3 rounded" />
                </div>
                <div className="space-y-2">
                  <div className="skeleton-loader h-4 w-full rounded" />
                  <div className="skeleton-loader h-5 w-2/3 rounded" />
                </div>
              </div>
              <div className="border-t pt-3">
                <div className="skeleton-loader h-4 w-1/2 rounded" />
              </div>
            </div>
          </div>
        ))}
      </>
    );
  }

  if (type === 'list') {
    return (
      <div className={cn('space-y-2', className)}>
        {items.map((index) => (
          <div key={index} className="skeleton-loader h-12 w-full rounded" />
        ))}
      </div>
    );
  }

  return (
    <>
      {items.map((index) => (
        <div key={index} className={cn('skeleton-loader h-4 w-full rounded', className)} />
      ))}
    </>
  );
}

// Ward list skeleton loader
export function WardListSkeleton() {
  return (
    <div className="space-y-4 p-4">
      <SkeletonLoader type="card" count={5} />
    </div>
  );
}

// Map skeleton loader
export function MapSkeleton() {
  return (
    <div className="relative h-full w-full bg-gray-100">
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center">
          <div className="skeleton-loader mx-auto mb-4 h-12 w-12 rounded-full" />
          <div className="skeleton-loader mx-auto h-4 w-32 rounded" />
        </div>
      </div>
      <div className="absolute bottom-4 right-4 space-y-2">
        <div className="skeleton-loader h-10 w-10 rounded" />
        <div className="skeleton-loader h-10 w-10 rounded" />
        <div className="skeleton-loader h-10 w-10 rounded" />
      </div>
    </div>
  );
}
